import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 1v22h14V1H5zm12 18H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z"
}), 'SystemUpdateSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SystemUpdateSharp.js
// module id = 6661
// module chunks = 2